import React from 'react';
import { Play } from 'lucide-react';
import LightEffects from './LightEffects';

const Showreel = () => {
  const handlePlayClick = () => {
    // Placeholder for video playback
    alert('Showreel video will be integrated here. Please provide your video URL to complete this section.');
  };

  return (
    <section className="relative bg-black py-24 md:py-32">
      {/* Light Effects */}
      <LightEffects variant="strobe" />
      
      <div className="container mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-semibold text-white mb-6 tracking-tight">
            See LFXPro in Action
          </h2>
          <div className="h-1 w-24 bg-blue-500 mx-auto mb-6"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto leading-relaxed">
            Watch our showreel to experience the full spectrum of lighting excellence
          </p>
        </div>

        {/* Video Placeholder */}
        <div className="max-w-6xl mx-auto">
          <div
            className="relative aspect-video bg-gradient-to-br from-blue-900/20 to-black border border-white/10 overflow-hidden group cursor-pointer"
            onClick={handlePlayClick}
          >
            {/* Background Image */}
            <img
              src="https://images.unsplash.com/photo-1765278248871-1d574fb1392d"
              alt="Showreel Preview"
              className="w-full h-full object-cover opacity-30 transition-transform duration-700 group-hover:scale-105"
            />
            
            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-black/60"></div>

            {/* Play Button */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-24 h-24 bg-blue-600 flex items-center justify-center transition-all duration-500 group-hover:bg-blue-700 group-hover:scale-110">
                <Play size={40} className="text-white ml-2" fill="white" />
              </div>
            </div>

            {/* Text Overlay */}
            <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-black to-transparent">
              <h3 className="text-2xl font-semibold text-white mb-2">
                LFXPro Lights Showreel 2025
              </h3>
              <p className="text-base text-white/70">
                Showcasing our premium lighting installations worldwide
              </p>
            </div>

            {/* Blue accent on hover */}
            <div className="absolute top-0 left-0 w-0 h-1 bg-blue-500 transition-all duration-500 group-hover:w-full"></div>
          </div>

          {/* Video Info */}
          <div className="mt-8 text-center">
            <p className="text-sm text-white/50">
              Click to play showreel • Video placeholder - awaiting your showreel URL
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Showreel;
